<template>
    <el-dialog
        :title="
            $t('project.component_MultiColumnExcelParseDialog_dialog_title')
        "
        :visible.sync="show"
        destroy-on-close
        width="600px"
        top="20px"
        @close="onClosed"
    >
        <div>
            <el-checkbox
                v-model="notParseFirstRow"
                :disabled="!enable"
                :label="
                    $t(
                        'project.component_MultiColumnExcelParseDialog_dialog_tips_1'
                    )
                "
            ></el-checkbox>
        </div>
        <div class="language-form">
            <div class="form-scroll-container">
                <el-form
                    :disabled="!enable"
                    label-width="180px"
                    label-position="left"
                    size="small"
                >
                    <el-form-item
                        :label="
                            $t(
                                'project.component_MultiColumnExcelParseDialog_dialog_tips_2'
                            )
                        "
                        class="text-weight-600"
                    >
                        <div>
                            {{
                                $t(
                                    "project.component_MultiColumnExcelParseDialog_dialog_tips_4"
                                )
                            }}
                        </div>
                    </el-form-item>
                    <el-form-item :label="LANGUAGE_DICT[source.lang]?.name">
                        <el-input
                            v-model="source.col"
                            @input="handleColInput"
                            :maxlength="3"
                            :placeholder="
                                $t(
                                    'project.component_MultiColumnExcelParseDialog_dialog_tips_5'
                                )
                            "
                            style="width: 180px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        :label="
                            $t(
                                'project.component_MultiColumnExcelParseDialog_dialog_tips_10'
                            )
                        "
                        class="text-weight-600"
                    >
                        <el-input
                            v-model="translationNotes"
                            @input="handleTranslationNotesInput"
                            :maxlength="3"
                            :placeholder="
                                $t(
                                    'project.component_MultiColumnExcelParseDialog_dialog_tips_5'
                                )
                            "
                            style="width: 180px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        :label="
                            $t(
                                'project.component_MultiColumnExcelParseDialog_dialog_tips_11'
                            )
                        "
                        class="text-weight-600"
                    >
                        <el-input
                            v-model="charLimit"
                            @input="handleCharLimitInput"
                            :maxlength="3"
                            :placeholder="
                                $t(
                                    'project.component_MultiColumnExcelParseDialog_dialog_tips_5'
                                )
                            "
                            style="width: 180px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        :label="
                            $t(
                                'project.component_MultiColumnExcelParseDialog_dialog_tips_3'
                            )
                        "
                        class="margin-t-15 text-weight-600"
                    >
                        <div>
                            {{
                                $t(
                                    "project.component_MultiColumnExcelParseDialog_dialog_tips_4"
                                )
                            }}
                        </div>
                    </el-form-item>
                    <template v-for="(lang, index) in targets">
                        <el-form-item
                            :label="LANGUAGE_DICT[lang.lang]?.name"
                            :key="index"
                        >
                            <el-input
                                v-model="lang.col"
                                @input="(val) => handleColInput(val, index)"
                                :maxlength="3"
                                :placeholder="
                                    $t(
                                        'project.component_MultiColumnExcelParseDialog_dialog_tips_5'
                                    )
                                "
                                style="width: 180px"
                            ></el-input>
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div class="fonts-12 color-808080 margin-t-40 line-height-1.5">
                {{
                    $t(
                        "project.component_MultiColumnExcelParseDialog_dialog_tips_6"
                    )
                }}<br />
                {{
                    $t(
                        "project.component_MultiColumnExcelParseDialog_dialog_tips_7"
                    )
                }}<a
                    href="http://nextcat-prod.oss-accelerate-overseas.aliyuncs.com/files/public/excel%E5%A4%9A%E5%88%97%E7%BF%BB%E8%AF%91%E6%96%87%E6%A1%A3%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx"
                    >{{
                        $t(
                            "project.component_MultiColumnExcelParseDialog_dialog_tips_9"
                        )
                    }}</a
                ><br />
                {{
                    $t(
                        "project.component_MultiColumnExcelParseDialog_dialog_tips_8"
                    )
                }}
            </div>
        </div>
        <div class="text-center margin-t-20" v-if="enable">
            <el-button @click="show = false" plain round size="small">{{
                $t("project.component_MultiColumnExcelParseDialog_dialog_btn_1")
            }}</el-button>
            <el-button @click="saveEvent" type="primary" size="small" round>{{
                $t("project.component_MultiColumnExcelParseDialog_dialog_btn_2")
            }}</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from "vuex";

export default {
    components: {},
    data() {
        return {
            show: false,
            notParseFirstRow: false,
            source: {
                lang: "",
                col: "",
            },
            targets: [],
            translationNotes: "",
            charLimit: "",
            enable: true,
            maxCols: 300,
            colOptions: [],
        };
    },
    computed: {
        ...mapState({
            LANGUAGE_DICT: (state) => state.common.LANGUAGE_DICT,
        }),
    },
    methods: {
        setShow(data) {
            // this.colOptions = this.generateExcelColumnNames(this.maxCols);
            this.notParseFirstRow = data.notParseFirstRow || false;
            this.source = data.source || { lang: "", col: "" };
            this.targets = data.targets || [];
            this.translationNotes = data.translationNotes || "";
            this.charLimit = data.charLimit || "";
            this.enable = data.enable !== false;
            this.show = true;
        },
        saveEvent() {
            let tList = this.targets.filter((t) => t.col === "");
            if (tList.length > 0 || this.source.col === "") {
                this.$message.error(
                    this.$t(
                        "project.component_MultiColumnExcelParseDialog_method_saveBtnEvent_message_1"
                    )
                );
                return;
            }
            this.show = false;
        },
        onClosed() {
            if (!this.enable) {
                return;
            }
            const data = {
                notParseFirstRow: this.notParseFirstRow,
                source: this.source,
                targets: this.targets,
                translationNotes: this.translationNotes,
                charLimit: this.charLimit,
            };
            this.$emit("save", data);
        },
        handleColInput(value, index) {
            let str = value.toUpperCase().replace(/[^A-Z]/g, "");
            if (this.calculateAscii(str) > this.calculateAscii("XFD")) {
                str = "XFD";
            }
            if (index !== undefined) {
                this.targets[index].col = str;
            } else {
                this.source.col = str;
            }
        },
        handleTranslationNotesInput(value) {
            let str = value.toUpperCase().replace(/[^A-Z]/g, "");
            if (this.calculateAscii(str) > this.calculateAscii("XFD")) {
                str = "XFD";
            }
            this.translationNotes = str;
        },
        handleCharLimitInput(value) {
            let str = value.toUpperCase().replace(/[^A-Z]/g, "");
            if (this.calculateAscii(str) > this.calculateAscii("XFD")) {
                str = "XFD";
            }
            this.charLimit = str;
        },
        calculateAscii(str) {
            let sum = "";
            for (let i = 0; i < str.length; i++) {
                const char = str[i];
                const asciiValue = char.charCodeAt(0);
                sum += asciiValue;
            }
            return parseInt(sum);
        },
        resetData() {
            this.notParseFirstRow = false;
            this.source = { lang: "", col: "" };
            this.targets = [];
        },
        generateExcelColumnNames(n) {
            const result = [];
            for (let i = 1; i <= n; i++) {
                let columnName = "";
                let num = i;
                while (num > 0) {
                    const remainder = (num - 1) % 26;
                    columnName =
                        String.fromCharCode(65 + remainder) + columnName;
                    num = Math.floor((num - 1) / 26);
                }
                result.push(columnName);
            }
            return result;
        },
    },
};
</script>
<style lang="scss" scoped>
.language-form {
    margin-top: 15px;

    .form-scroll-container {
        max-height: 400px;
        overflow-y: auto;
        padding-right: 10px;
    }

    .el-form-item {
        margin-bottom: 8px;
    }

    ::v-deep .el-form-item__label {
        color: #000;
    }
}
</style>
